<!--suppress ALL -->
<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div
                                    class="card card-lift shadow border-0 card-address_page mb-3"
                            >
                                <el-breadcrumb
                                        separator-class="el-icon-arrow-right"
                                        class="vertical-center"
                                >
                                    <el-breadcrumb-item :to="{ path: '/' }">{{
                                        $t("menu.main")
                                        }}
                                    </el-breadcrumb-item>
                                    <el-breadcrumb-item>{{
                                        $t("menu.press")
                                        }}
                                    </el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
        <section class="section py-3">
            <div class="container">
                <el-row :gutter="10">
                    <el-col :sm="24" :md="24" :lg="18">
                        <el-button :class="activeName==='news' ? 'button_active category_button' : 'button_normal category_button'"
                                   @click="() => handleClick({ name: 'news' })">{{ $t('submenu.news') }}
                        </el-button>
                        <el-button :class="activeName==='fast_news' ? 'button_active category_button' : 'button_normal category_button'"
                                   @click="() => handleClick({ name: 'fast_news' })">{{ $t('submenu.fast_news') }}
                        </el-button>
                        <el-button :class="activeName==='gender_equality' ? 'button_active category_button' : 'button_normal category_button'"
                                   @click="() => handleClick({ name: 'gender_equality' })">{{
                            $t('homepage.gender_equality') }}
                        </el-button>
                      <el-button :class="activeName==='manaviyat_marifat' ? 'button_active category_button' : 'button_normal category_button'"
                                 @click="() => handleClick({ name: 'manaviyat_marifat' })">{{
                          $t('homepage.manaviyat_marifat') }}
                      </el-button>
                      <el-button :class="activeName==='korrupsiyaga_qkurash' ? 'button_active category_button' : 'button_normal category_button'"
                                 @click="() => handleClick({ name: 'korrupsiyaga_qkurash' })">{{
                          $t('homepage.korrupsiyaga_qkurash') }}
                      </el-button>
                      <el-button :class="activeName==='constitution_page' ? 'button_active category_button' : 'button_normal category_button'"
                                 @click="() => handleClick({ name: 'constitution_page' })">{{
                          $t('homepage.constitution_page') }}
                      </el-button>
                        <div v-if="activeName === 'news'">
                            <div class="tab_div_top">
                                <el-row :gutter="15">
                                    <el-col :sm="12" :md="12" :lg="8" class="mb-3" v-for="(item, index) in news">
                                        <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                            <router-link :to="`/newsview?id=${item.id}`">
                                                <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                                     class="card-img-top">
                                                <span class="press_news_status" v-if="index === 0 || index === 1 || index === 2">{{$t('submenu.news_u')}}</span>
                                                <blockquote class="card-blockquote">
                                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 583 95"
                                                         class="svg-bg">
                                                        <polygon points="0,52 583,95 0,95"
                                                                 class="fill-defaultnew"></polygon>
                                                        <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                                                 class="fill-default"></polygon>
                                                    </svg>
                                                    <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                                    <h4 v-if="$i18n.locale === 'uz-UZ'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleUzLat}}</h4>
                                                    <h4 v-if="$i18n.locale === 'uz-CYR'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleUz}}</h4>
                                                    <h4 v-if="$i18n.locale === 'ru-RU'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.tilteRu}}</h4>
                                                    <h4 v-if="$i18n.locale === 'en-US'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleEn}}</h4>
                                                </blockquote>
                                            </router-link>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div v-if="activeName === 'fast_news'">
                            <div class="tab_div_top">
                                <el-row :gutter="15">
                                    <el-col :sm="12" :md="12" :lg="8" class="mb-3" v-for="(item, index) in news">
                                        <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                            <router-link :to="`/newsview?id=${item.id}`">
                                                <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                                     class="card-img-top">
                                                <span class="press_fastnews_status" v-if="index === 0 || index === 1 || index === 2">{{$t('submenu.fast_news')}}</span>
                                                <blockquote class="card-blockquote">
                                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 583 95"
                                                         class="svg-bg">
                                                        <polygon points="0,52 583,95 0,95"
                                                                 class="fill-defaultnew"></polygon>
                                                        <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                                                 class="fill-default"></polygon>
                                                    </svg>
                                                    <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                                    <h4 v-if="$i18n.locale === 'uz-UZ'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleUzLat}}</h4>
                                                    <h4 v-if="$i18n.locale === 'uz-CYR'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleUz}}</h4>
                                                    <h4 v-if="$i18n.locale === 'ru-RU'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.tilteRu}}</h4>
                                                    <h4 v-if="$i18n.locale === 'en-US'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleEn}}</h4>
                                                </blockquote>
                                            </router-link>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div v-if="activeName === 'gender_equality'">
                            <div class="tab_div_top">
                                <el-row :gutter="15">
                                    <el-col :sm="12" :md="12" :lg="8" class="mb-3" v-for="(item, index) in news">
                                        <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                            <router-link :to="`/newsview?id=${item.id}`">
                                                <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                                     class="card-img-top">
                                                <span class="press_fastnews_status" v-if="index === 0 || index === 1 || index === 2">{{$t('homepage.gender_equality')}}</span>
                                                <blockquote class="card-blockquote">
                                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 583 95"
                                                         class="svg-bg">
                                                        <polygon points="0,52 583,95 0,95"
                                                                 class="fill-defaultnew"></polygon>
                                                        <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                                                 class="fill-default"></polygon>
                                                    </svg>
                                                    <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                                    <h4 v-if="$i18n.locale === 'uz-UZ'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleUzLat}}</h4>
                                                    <h4 v-if="$i18n.locale === 'uz-CYR'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleUz}}</h4>
                                                    <h4 v-if="$i18n.locale === 'ru-RU'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.tilteRu}}</h4>
                                                    <h4 v-if="$i18n.locale === 'en-US'"
                                                        class="display-3 text-titlecolor title_text">
                                                        {{item.titleEn}}</h4>
                                                </blockquote>
                                            </router-link>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div v-if="activeName === 'manaviyat_marifat'">
                        <div class="tab_div_top">
                          <el-row :gutter="15">
                            <el-col :sm="12" :md="12" :lg="8" class="mb-3" v-for="(item, index) in news">
                              <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link :to="`/newsview?id=${item.id}`">
                                  <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                       class="card-img-top">
                                  <span class="press_fastnews_status" v-if="index === 0 || index === 1 || index === 2">{{$t('homepage.manaviyat_marifat')}}</span>
                                  <blockquote class="card-blockquote">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 583 95"
                                         class="svg-bg">
                                      <polygon points="0,52 583,95 0,95"
                                               class="fill-defaultnew"></polygon>
                                      <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                               class="fill-default"></polygon>
                                    </svg>
                                    <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                    <h4 v-if="$i18n.locale === 'uz-UZ'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleUzLat}}</h4>
                                    <h4 v-if="$i18n.locale === 'uz-CYR'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleUz}}</h4>
                                    <h4 v-if="$i18n.locale === 'ru-RU'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.tilteRu}}</h4>
                                    <h4 v-if="$i18n.locale === 'en-US'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleEn}}</h4>
                                  </blockquote>
                                </router-link>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                        <div v-if="activeName === 'korrupsiyaga_qkurash'">
                        <div class="tab_div_top">
                          <el-row :gutter="15">
                            <el-col :sm="12" :md="12" :lg="8" class="mb-3" v-for="(item, index) in news">
                              <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link :to="`/newsview?id=${item.id}`">
                                  <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                       class="card-img-top">
                                  <span class="press_fastnews_status" v-if="index === 0 || index === 1 || index === 2">{{$t('homepage.korrupsiyaga_qkurash')}}</span>
                                  <blockquote class="card-blockquote">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 583 95"
                                         class="svg-bg">
                                      <polygon points="0,52 583,95 0,95"
                                               class="fill-defaultnew"></polygon>
                                      <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                               class="fill-default"></polygon>
                                    </svg>
                                    <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                    <h4 v-if="$i18n.locale === 'uz-UZ'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleUzLat}}</h4>
                                    <h4 v-if="$i18n.locale === 'uz-CYR'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleUz}}</h4>
                                    <h4 v-if="$i18n.locale === 'ru-RU'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.tilteRu}}</h4>
                                    <h4 v-if="$i18n.locale === 'en-US'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleEn}}</h4>
                                  </blockquote>
                                </router-link>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </div>

                      <div v-if="activeName === 'constitution_page'">
                        <div class="tab_div_top">
                          <el-row :gutter="15">
                            <el-col :sm="12" :md="12" :lg="8" class="mb-3" v-for="(item, index) in news">
                              <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link :to="`/newsview?id=${item.id}`">
                                  <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                       class="card-img-top">
                                  <span class="press_fastnews_status" v-if="index === 0 || index === 1 || index === 2">{{$t('homepage.constitution_page')}}</span>
                                  <blockquote class="card-blockquote">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 583 95"
                                         class="svg-bg">
                                      <polygon points="0,52 583,95 0,95"
                                               class="fill-defaultnew"></polygon>
                                      <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                               class="fill-default"></polygon>
                                    </svg>
                                    <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                    <h4 v-if="$i18n.locale === 'uz-UZ'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleUzLat}}</h4>
                                    <h4 v-if="$i18n.locale === 'uz-CYR'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleUz}}</h4>
                                    <h4 v-if="$i18n.locale === 'ru-RU'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.tilteRu}}</h4>
                                    <h4 v-if="$i18n.locale === 'en-US'"
                                        class="display-3 text-titlecolor title_text">
                                      {{item.titleEn}}</h4>
                                  </blockquote>
                                </router-link>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                    </el-col>
                    <el-col :sm="24" :md="24" :lg="6" class="mb-lg-10">
                            <el-col :sm="24" :md="12" :lg="24" class="mb-3">
                                <div style="text-align: center;">
                                    <div class="card card-lift shadow border-0 card-img_card_calendar">
                                        <h5 class="card_new_title">{{$t('homepage.calendar')}}</h5>
                                        <div>
                                            <v-calendar :attributes="attributes" @dayclick="onDayClick" is-expanded style="border: 0px; margin-left: -7px;"></v-calendar>
                                        </div>
                                    </div>
                                    <!--                                <router-link to="/pressservice" class="mt-3 button_new_m btnnew_primary">-->
                                    <!--                                    {{$t('homepage.button_news')}}-->
                                    <!--                                </router-link>-->
                                </div>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="24">
                                <div class="card card-lift shadow border-0 card-img_card_news">
                                    <h5 class="card_new_title">{{ $t("homepage.last_news") }}</h5>
                                    <div class="card_news_items">
                                        <div v-for="(item, lnIndex) in lastNews" :key="'lastNews_'+lnIndex">
                                            <div class="time_info">
                                                <span>{{ parseDate(item.createdDate) }}</span>
                                                <hr/>
                                                <span v-if="$i18n.locale === 'uz-UZ'">{{item.category.nameUzLat}}</span>
                                                <span v-if="$i18n.locale === 'uz-CYR'">{{item.category.nameUz}}</span>
                                                <span v-if="$i18n.locale === 'ru-RU'">{{item.category.nameRu}}</span>
                                                <span v-if="$i18n.locale === 'en-US'">{{item.category.nameEn}}</span>
                                            </div>
                                            <router-link :to="`/newsview?id=${item.id}`">
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'uz-UZ'">{{item.titleUzLat}}</span>
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'uz-CYR'">{{item.titleUz}}</span>
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'ru-RU'">{{item.tilteRu}}</span>
                                                <span class="card_new_span_l" v-if="$i18n.locale === 'en-US'">{{item.titleEn}}</span>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                    </el-col>
                </el-row>

                <div style="display: flex; justify-content: center; align-items: center; margin-top: 12px">
                    <el-pagination
                            align="center"
                            background
                            layout="prev, pager, next"
                            @current-change="onPageChange"
                            :current-page.sync="paging.current"
                            :page-size="paging.size"
                            :total="paging.total">
                    </el-pagination>
                    <span style="margin-left: 16px">{{$t('app.bosh_stat')}} {{ paging.total }}</span>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data() {
            return {
                selectedDate: "",
                days: [],
                activeName: "news",
                pagination: {
                    default: 1
                },
                categories: [],
                categoryId: 1,
                news: [],
                lastNews: [],
                currentNews: null,
                paging: {
                    sort: null,
                    page: 0,
                    size: 12,
                    total: 0,
                    current: 1
                }
            };
        },
        computed: {
            dates() {
                return this.days.map(day => day.date);
            },
            attributes() {
                return this.dates.map(date => ({
                    highlight: true,
                    dates: date,
                }));
            },
        },
        methods: {
            onDayClick(day) {
                if (this.days.length > 0 && day.id === this.days[0].id) {
                    this.days = [];
                    this.selectedDate = "";
                } else {
                    this.days = [];
                    const idx = this.days.findIndex(d => d.id === day.id);
                    if (idx >= 0) {
                        this.days.splice(idx, 1);
                    } else {
                        this.days.push({
                            id: day.id,
                            date: day.date,
                        });
                    }
                    this.selectedDate = this.days[0].id;
                }
                this.paging.page = 0;
                this.paging.current = 1;
                this.loadNewsByCategory();
            },
            handleClick(tab, event) {
                this.activeName = tab.name;
                this.paging.current = 1;
                switch (tab.name) {
                    case "news":
                        if (this.categoryId !== 1) {
                            this.categoryId = 1;
                            this.paging.page = 0;
                            this.paging.current = 1;
                            this.loadNewsByCategory();
                            break;
                        }
                    case "fast_news":
                        if (this.categoryId !== 2) {
                            this.categoryId = 2;
                            this.paging.page = 0;
                            this.paging.current = 1;
                            this.loadNewsByCategory();
                            break;
                        }
                    case "gender_equality":
                        if (this.categoryId !== 4) {
                            this.categoryId = 4;
                            this.paging.page = 0;
                            this.paging.current = 1;
                            this.loadNewsByCategory();
                            break;
                        }
                    case "manaviyat_marifat":
                        if (this.categoryId !== 10) {
                            this.categoryId = 10;
                            this.paging.page = 0;
                            this.paging.current = 1;
                            this.loadNewsByCategory();
                            break;
                        }
                    case "korrupsiyaga_qkurash":
                        if (this.categoryId !== 11) {
                            this.categoryId = 11;
                            this.paging.page = 0;
                            this.paging.current = 1;
                            this.loadNewsByCategory();
                            break;
                        }
                    case "constitution_page":
                        if (this.categoryId !== 15) {
                            this.categoryId = 15;
                            this.paging.page = 0;
                            this.paging.current = 1;
                            this.loadNewsByCategory();
                            break;
                        }
                }
            },
            loadNewsByCategory() {
                this.news = [];
                this.$axios
                    .get(
                        `https://www.prokuratura.uz/api/news/page/category-and-date/${this.categoryId}?page=${this.paging.page}&date=${this.selectedDate}`
                        // `http://172.18.45.189:8080/api/news/page/category-and-date/${this.categoryId}?page=${this.paging.page}&date=${this.selectedDate}`
                    )
                    .then(response => {
                        this.news = response.data.content;
                        this.paging.total = response.data.totalElements;
                    });
            },
            parseDate(dateTime) {
                return moment(dateTime).format("DD.MM.YYYY");
            },
            onPageChange(current) {
                this.paging.current = current;
                this.paging.page = current - 1;
                this.loadNewsByCategory();
            }
        },
        created() {
            this.days.push(new Date());
            this.loadNewsByCategory();
            this.$axios
                .get(`https://www.prokuratura.uz/api/news/last-news?size=8`)
                .then(response => {
                    this.lastNews = response.data.content;
                    this.currentNews = this.lastNews[0];
                });
        }
    };
</script>
<style scoped>
    .category_button{
      padding: 10px;
      margin: 5px;
    }
    .bg-defaultnew {
        background: #fff;
        cursor: pointer;
    }

    .press_news_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(57, 72, 105, 0.85);
    }

    .press_fastnews_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(207, 52, 118, 0.85);
    }

    .tab_div_top {
        min-height: 400px;
        margin-top: 15px;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 88px;
    }

    /deep/ .badge {
        display: inline-block;
        padding: 0.35rem 0.375rem;
        font-size: 76%;
        font-weight: 600;
        margin-left: -6px;
        line-height: 1;
        text-align: center;
        position: absolute;
        white-space: nowrap;
        top: -32px;
        vertical-align: baseline;
        border-radius: 0rem;
    }

    /deep/ .badge-primary {
        color: #394869;
        background-color: #f0f4f9;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 38px;
    }

    /deep/ .card-img-top {
        height: 240px;
        object-fit: cover;
        border-radius: 0px;
    }

    .textnew-title_color {
        color: #394869;
    }
    hr {
        border: none;
        border-left: 1px solid #00b0f0;
        height: 14px;
        margin: 4px 5px;
        width: 1px;
    }
</style>
